$(document).ready(function () {
    let fileManagerQuestionnaire = document.querySelector('#filemanager-questionnaire')
    let folder = fileManagerQuestionnaire.dataset.folder
    let dossier = fileManagerQuestionnaire.dataset.dossier

    let formElements = $('.drag-and-drop');

    const isAdvancedUpload = function () {
        let div = document.createElement('div');
        return (('draggable' in div) || ('ondragstart' in div && 'ondrop' in div)) && 'FormData' in window && 'FileReader' in window;
    }();

    if (isAdvancedUpload) {
        let droppedFiles = false;
        formElements.addClass('has-advanced-upload');

        formElements.each(function (element) {
            const fieldId = $(this).data('field-id');

            $('#file_upload_'+fieldId).on('change', function (e) {
                $(this).closest("form").trigger('submit');
            })

            $(this).on('drag dragstart dragend dragover dragenter dragleave drop', function (e) {
                e.preventDefault();
                e.stopPropagation();
            })
                .on('dragover dragenter', function () {
                    $(this).addClass('is-dragover');
                })
                .on('dragleave dragend drop', function () {
                    $(this).removeClass('is-dragover');
                })
                .on('drop', function (e) {
                    droppedFiles = e.originalEvent.dataTransfer.files;
                    if(droppedFiles?.length > 40) {
                        alert("Je kan niet meer dan 40 bestanden tegelijk uploaden in een vragenlijst.");
                        return;
                    }

                    // Loop through all files
                    let hasValidFileArray = true;
                    $.each(droppedFiles, function (i, file) {
                        if (file?.name !== null && file?.name?.endsWith('.zip')) {
                            hasValidFileArray = false;
                        }
                        if (file?.size !== null && file?.size  <= 0) {
                            hasValidFileArray = false;
                        }
                    });

                    // If file array is invalid we stop the upload
                    if (!hasValidFileArray) {
                        showErrorToast();
                        return;
                    }

                    $(this).trigger('submit');
                }).on('submit', function (e) {
                let inputDiv = $(this).find(".file-select");
                let uploadDiv = $(this).find(".file-uploading");
                let uploadFailedDiv = $(this).find(".file-upload-failed");

                uploadFailedDiv.addClass('d-none');
                inputDiv.addClass('d-none');
                uploadDiv.removeClass('d-none');

                // Check if currently not uploading already
                if ($(this).hasClass('is-uploading')) return false;
                $(this).addClass('is-uploading').removeClass('is-error');

                if (isAdvancedUpload) {
                    e.preventDefault();

                    let ajaxData = new FormData($(this).get(0));
                    let $input = $(this).find('input[type="file"]')

                    if (droppedFiles) {
                        $.each(droppedFiles, function (i, file) {
                            ajaxData.append($input.attr('name'), file);
                        });
                    }
                    const fieldId = $(this).data('field-id');

                    $.ajax({
                        url: '/files/' + dossier + '/upload-folder-field/' + fieldId + '/' + folder,
                        type: $(this).attr('method'),
                        data: ajaxData,
                        dataType: 'json',
                        cache: false,
                        contentType: false,
                        processData: false,
                        success: function (data) {
                            setTimeout(() => {
                                uploadFailedDiv.addClass('d-none');
                                uploadDiv.addClass('d-none');
                                inputDiv.removeClass('d-none');
                                location.reload();
                            }, 2000);
                        },
                        error: function (error) {
                            if (error.status === 200) {
                                setTimeout(() => {
                                    uploadFailedDiv.addClass('d-none');
                                    uploadDiv.addClass('d-none');
                                    inputDiv.removeClass('d-none');
                                    location.reload();
                                }, 2000);
                            } else {
                                setTimeout(() => {
                                    uploadDiv.addClass('d-none');
                                    inputDiv.addClass('d-none');
                                    uploadFailedDiv.removeClass('d-none');
                                }, 2000);
                            }
                        }
                    });
                } else {
                    // TODO: Do something for legacy browsers
                }
            });
        });
    }

    function showErrorToast() {
        /** Custom alert box for incorrect file uploads */
        window.alert = () => {
            let target;

            /** Check if event object is available */
            if (event) {
                event.preventDefault();
                target = $(event.target);
            }
            let modal = $(target ? target.data('confirm-modal') ?? '#js-confirm-modal' : '#js-confirm-modal');
            modal.find('.modal-body .text').html('Een of meerdere van de geüploade bestanden zijn niet geldig. ' +
                'Probeer het opnieuw. <br/><br/>Probeert u direct vanuit een <strong>.zip</strong> of <strong>.rar</strong> bestand te uploaden naar de vragenlijst? ' +
                'Pak het <strong>.zip</strong> of <strong>.rar</strong> bestand eerst lokaal uit en upload de uitgepakte bestanden naar Digidos.');
            modal.find('button').hide();
            modal.find('button.confirm').show();
            modal.find('button.confirm').html('Sluiten');
            modal.find('button.confirm').click(function () {
                modal.modal('hide');
                setTimeout(function () {
                    window.location.reload();
                }, 200);
            });
            modal.modal('show');
        };
        alert();
    }
});
